import { Component, inject, OnInit, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { UserService } from '../../../services/user.service';
import { ToolbarService } from '../../../services/toolbar.service';
import { MessagingService } from '../../../components/messaging/messaging.service';
import { EscapeDialogHelper } from '../../../helpers/escape-dialog.helper';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-remove-job',
  templateUrl: './remove-job.component.html',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatDivider,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton
  ]
})
export class RemoveJobComponent implements OnInit {
  #userService = inject(UserService);
  #message = inject(MessagingService);
  #escapeDialogRef = inject(EscapeDialogHelper);

  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<RemoveJobComponent>);
  toolbarService = inject(ToolbarService);

  pending = signal(false);

  ngOnInit(): void {
    this.#escapeDialogRef.escapeDialog(this.dialogRef);
  }

  hideJob() {
    this.pending.set(true);
    this.toolbarService.setCloudState('SAVING');
    this.#userService.archiveExternallyCostControlledJob(this.data.jobId).subscribe({
      next: () => this.dialogRef.close('Success'),
      error: () => {
        this.#message.error('Could not remove from dashboard.');
        this.toolbarService.setCloudState('RESTING');
        this.pending.set(false);
      },
      complete: () => {
        this.#message.confirm('Job removed from dashboard.');
        this.toolbarService.setCloudState('RESTING');
        this.pending.set(false);
      }
    });
  }
}
